import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { getFounderId } from "@/lib/founder";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Small pill that shows "used / limit reports" for the current browser founder.
 * Refreshes when the `refreshKey` prop changes.
 */
export default function UsagePill({ refreshKey = 0, className = "" }) {
  const [usage, setUsage] = useState(null);

  const fetchUsage = useCallback(async () => {
    try {
      const founderId = getFounderId();
      const { data } = await axios.get(`${API}/usage/${founderId}`);
      setUsage(data);
    } catch (error) {
      console.warn("UsagePill: failed to fetch usage", error);
      setUsage(null);
    }
  }, []);

  useEffect(() => {
    fetchUsage();
  }, [refreshKey, fetchUsage]);

  if (!usage) return null;

  const pct = Math.min(100, Math.round((usage.credits_used / usage.credits_limit) * 100));
  const tone =
    usage.over_limit ? "label-red"
    : pct >= 80    ? "label-amber"
    :                "label-green";

  return (
    <span
      data-testid="usage-pill"
      className={`inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-white px-3 py-1 text-xs font-semibold ${className}`}
      title="Credits used this browser"
    >
      <span className={`rounded-full px-2 py-0.5 text-[10px] uppercase tracking-wider ${tone}`}>
        {usage.credits_used} / {usage.credits_limit}
      </span>
      <span className="text-zinc-600">reports</span>
    </span>
  );
}
